import { Api as api } from "../api";
const prefix = "/master-data";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    vehicleAuxiliaryServiceV1GetVehicleAuxiliaryDropdown: build.query<
      VehicleAuxiliaryServiceV1GetVehicleAuxiliaryDropdownApiResponse,
      VehicleAuxiliaryServiceV1GetVehicleAuxiliaryDropdownApiArg
    >({
      query: () => ({ url: `${prefix}/v1/vehicle-attachments/dropdown` }),
    }),
    vehicleAuxiliaryServiceV1ListVehicleAuxiliaries: build.query<
      VehicleAuxiliaryServiceV1ListVehicleAuxiliariesApiResponse,
      VehicleAuxiliaryServiceV1ListVehicleAuxiliariesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-auxiliary`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort: queryArg.sort,
          order: queryArg.order,
          status: queryArg.status,
          auxiliary_name: queryArg.auxiliaryName,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
        },
      }),
    }),
    vehicleAuxiliaryServiceV1BatchCreateVehicleAuxiliary: build.mutation<
      VehicleAuxiliaryServiceV1BatchCreateVehicleAuxiliaryApiResponse,
      VehicleAuxiliaryServiceV1BatchCreateVehicleAuxiliaryApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-auxiliary`,
        method: "POST",
        body: queryArg.vehicleAuxiliaryV1BatchCreateVehicleAuxiliaryReq,
      }),
    }),
    vehicleAuxiliaryServiceV1ActivateVehicleAuxiliaries: build.mutation<
      VehicleAuxiliaryServiceV1ActivateVehicleAuxiliariesApiResponse,
      VehicleAuxiliaryServiceV1ActivateVehicleAuxiliariesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-auxiliary/activate`,
        method: "PATCH",
        body: queryArg.vehicleAuxiliaryV1VehicleAuxiliaryBulkStatusChangeReq,
      }),
    }),
    vehicleAuxiliaryServiceV1DeactivateVehicleAuxiliaries: build.mutation<
      VehicleAuxiliaryServiceV1DeactivateVehicleAuxiliariesApiResponse,
      VehicleAuxiliaryServiceV1DeactivateVehicleAuxiliariesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-auxiliary/deactivate`,
        method: "PATCH",
        body: queryArg.vehicleAuxiliaryV1VehicleAuxiliaryBulkStatusChangeReq,
      }),
    }),
    vehicleAuxiliaryServiceV1GetVehicleAuxiliary: build.query<
      VehicleAuxiliaryServiceV1GetVehicleAuxiliaryApiResponse,
      VehicleAuxiliaryServiceV1GetVehicleAuxiliaryApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/vehicle-auxiliary/${queryArg.id}` }),
    }),
    vehicleAuxiliaryServiceV1UpdateVehicleAuxiliary: build.mutation<
      VehicleAuxiliaryServiceV1UpdateVehicleAuxiliaryApiResponse,
      VehicleAuxiliaryServiceV1UpdateVehicleAuxiliaryApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/vehicle-auxiliary/${queryArg.id}`,
        method: "PUT",
        body: queryArg.vehicleAuxiliaryServiceV1UpdateVehicleAuxiliaryBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as vehicleAuxiliaryApi };
export type VehicleAuxiliaryServiceV1GetVehicleAuxiliaryDropdownApiResponse =
  /** status 200 A successful response. */ VehicleAuxiliaryV1GetVehicleAuxiliaryDropdownRes;
export type VehicleAuxiliaryServiceV1GetVehicleAuxiliaryDropdownApiArg = void;
export type VehicleAuxiliaryServiceV1ListVehicleAuxiliariesApiResponse =
  /** status 200 A successful response. */ VehicleAuxiliaryV1ListVehicleAuxiliariesRes;
export type VehicleAuxiliaryServiceV1ListVehicleAuxiliariesApiArg = {
  page?: number;
  size?: number;
  sort?: string;
  order?: string;
  status?: string;
  auxiliaryName?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
};
export type VehicleAuxiliaryServiceV1BatchCreateVehicleAuxiliaryApiResponse =
  /** status 200 A successful response. */ VehicleAuxiliaryV1VehicleAuxiliaryMessageRes;
export type VehicleAuxiliaryServiceV1BatchCreateVehicleAuxiliaryApiArg = {
  vehicleAuxiliaryV1BatchCreateVehicleAuxiliaryReq: VehicleAuxiliaryV1BatchCreateVehicleAuxiliaryReq;
};
export type VehicleAuxiliaryServiceV1ActivateVehicleAuxiliariesApiResponse =
  /** status 200 A successful response. */ VehicleAuxiliaryV1VehicleAuxiliaryBulkStatusChangeRes;
export type VehicleAuxiliaryServiceV1ActivateVehicleAuxiliariesApiArg = {
  vehicleAuxiliaryV1VehicleAuxiliaryBulkStatusChangeReq: VehicleAuxiliaryV1VehicleAuxiliaryBulkStatusChangeReq;
};
export type VehicleAuxiliaryServiceV1DeactivateVehicleAuxiliariesApiResponse =
  /** status 200 A successful response. */ VehicleAuxiliaryV1VehicleAuxiliaryBulkStatusChangeRes;
export type VehicleAuxiliaryServiceV1DeactivateVehicleAuxiliariesApiArg = {
  vehicleAuxiliaryV1VehicleAuxiliaryBulkStatusChangeReq: VehicleAuxiliaryV1VehicleAuxiliaryBulkStatusChangeReq;
};
export type VehicleAuxiliaryServiceV1GetVehicleAuxiliaryApiResponse =
  /** status 200 A successful response. */ VehicleAuxiliaryV1VehicleAuxiliaryDetailRes;
export type VehicleAuxiliaryServiceV1GetVehicleAuxiliaryApiArg = {
  id: string;
};
export type VehicleAuxiliaryServiceV1UpdateVehicleAuxiliaryApiResponse =
  /** status 200 A successful response. */ VehicleAuxiliaryV1VehicleAuxiliaryMessageRes;
export type VehicleAuxiliaryServiceV1UpdateVehicleAuxiliaryApiArg = {
  id: string;
  vehicleAuxiliaryServiceV1UpdateVehicleAuxiliaryBody: VehicleAuxiliaryServiceV1UpdateVehicleAuxiliaryBody;
};
export type VehicleAuxiliaryV1VehicleAuxiliaryDropdownItemRes = {
  id?: string;
  name?: string;
  type?: string;
};
export type VehicleAuxiliaryV1GetVehicleAuxiliaryDropdownRes = {
  vehicle_attachments?: VehicleAuxiliaryV1VehicleAuxiliaryDropdownItemRes[];
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type VehicleAuxiliaryV1VehicleAuxiliaryRes = {
  id?: string;
  auxiliary_name?: string;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type VehicleAuxiliaryV1VehicleAuxiliaryPaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type VehicleAuxiliaryV1ListVehicleAuxiliariesRes = {
  vehicle_auxiliary?: VehicleAuxiliaryV1VehicleAuxiliaryRes[];
  metadata?: VehicleAuxiliaryV1VehicleAuxiliaryPaginationMeta;
};
export type VehicleAuxiliaryV1VehicleAuxiliaryMessageRes = {
  message?: string;
};
export type VehicleAuxiliaryV1CreateVehicleAuxiliaryItem = {
  auxiliary_name: string;
  status: string;
};
export type VehicleAuxiliaryV1BatchCreateVehicleAuxiliaryReq = {
  items: VehicleAuxiliaryV1CreateVehicleAuxiliaryItem[];
};
export type VehicleAuxiliaryV1VehicleAuxiliaryBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type VehicleAuxiliaryV1VehicleAuxiliaryBulkStatusChangeReq = {
  ids: string[];
};
export type VehicleAuxiliaryV1VehicleAuxiliaryDetailRes = {
  id?: string;
  auxiliary_name?: string;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type VehicleAuxiliaryServiceV1UpdateVehicleAuxiliaryBody = {
  auxiliary_name: string;
};
export const {
  useVehicleAuxiliaryServiceV1GetVehicleAuxiliaryDropdownQuery,
  useVehicleAuxiliaryServiceV1ListVehicleAuxiliariesQuery,
  useVehicleAuxiliaryServiceV1BatchCreateVehicleAuxiliaryMutation,
  useVehicleAuxiliaryServiceV1ActivateVehicleAuxiliariesMutation,
  useVehicleAuxiliaryServiceV1DeactivateVehicleAuxiliariesMutation,
  useVehicleAuxiliaryServiceV1GetVehicleAuxiliaryQuery,
  useVehicleAuxiliaryServiceV1UpdateVehicleAuxiliaryMutation,
} = injectedRtkApi;
